/*
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import { Box, Typography, TextField, Button, Link, Dialog, DialogTitle, DialogContent, DialogActions, Avatar } from '@mui/material';
import { useHistory } from 'react-router-dom';

function PhotosCommentsPage() {
   const { id } = useParams();
   const [photo, setPhoto] = useState(null);
   const [comments, setComments] = useState([]);
   const [newComment, setNewComment] = useState('');
   const history = useHistory();
   const [open, setOpen] = useState(false);
   const [title, setTitle] = useState('');
   const [content, setContent] = useState('');


   const [openDialog, setOpenDialog] = useState(false);
   const [comment, setComment] = useState("");
   const [activePostId, setActivePostId] = useState(null);


   const [replyOpen, setReplyOpen] = useState(false);
   const [replyText, setReplyText] = useState("");
   const [activeCommentId, setActiveCommentId] = useState(null);


   // fetch main social photos 
   useEffect(() => {
       axios.get(`/photo/${id}`)
           .then(res => setPhoto(res.data))
           .catch(err => console.error("Error loading case", err));
       }, [id]);

   
   // Fetch comments
   useEffect(() => {
   axios.get(`/photo/${id}/comments`)
       .then(res => setComments(res.data))
       .catch(err => console.error("Error loading comments", err));
   }, [id]);


   const handleSubmitComment = async () => {
       if (!newComment.trim()) return;

       try {
           const res = await axios.post(`/photo/${id}/comment`, { text: newComment }); // NOTE: single 'comment'
           setComments(prev => [res.data, ...prev]);
           setNewComment('');
       } catch (err) {
           console.error("Error submitting comment", err);
       }
   };


   const toggleVote = async (postId) => {
       try {
           const res = await axios.post(`/photos/${postId}/upvote`);
           const { upvotes, voted } = res.data;


           setPhoto(prevCase => ({
               ...prevCase,
               upvotes,
               voted
           }));
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };


   const handleOpenDialog = (scotusCaseId) => {
      setActivePostId(scotusCaseId);
      setOpenDialog(true);
   };


   const toggleCommentVote = async (commentId) => {
       try {
               // hit backend endpoint that toggles a vote
               const res = await axios.post(`/photoComments/${commentId}/upvote`);


               // update <posts> in react state so ui rerenders
               // setPosts(prev => ...) receives the previous array of posts and must return a new array
               // prev.map( p => { ... } )
               // iterate through every post p in old array
               // if p is the one user just voted on, return a new object with the fresh upvote info from server
               // otherwise, return p unchanged
           setComments((prev) =>
               prev.map((p) =>
                   p._id === commentId
                       ? {
                           ...p, // copy exisiting post fields
                           upvotes: res.data.upvotes, // updated count
                           voted:   res.data.voted // true or false that user voted
                       }
                       : p // all other posts unchanged
               )
           );




       } catch(err) {
           console.error("Vote error", err);
       }
   };




   const handleReplyOpen = (commentId) => {
       setActiveCommentId(commentId);
       setReplyOpen(true);
   };




   const handleReplyClose = () => {
       setReplyOpen(false);
       setReplyText("");
       setActiveCommentId(null);
   };




   const handleReplySubmit = async () => {
       if (!replyText.trim()) return;


       try {
       const res = await axios.post(`/photo/comments/${activeCommentId}/replies`, {
           text: replyText
       });


       // Update state with new reply
       setComments(prev =>
           prev.map(c =>
           c._id === activeCommentId
               ? { ...c, replies: [...(c.replies || []), res.data] }
               : c
           )
       );


       handleReplyClose();
       } catch (err) {
       console.error("Reply error", err);
       }
   };

   if (!photo) {
     return <div>Loading post...</div>;
   }

return (
       <div
          style={{
              padding: '20px',
              backgroundColor: '#FFFDF8',
              minHeight: '100vh',  // ensures it covers the full viewport height
              boxSizing: 'border-box', // ensures padding doesn't affect layout
          }}
      >

          <div style={{ width: '200px' }}></div>

           <Box
               p={2} // padding inside box
               my={2} // vertical margin between posts
               border="1px solid #ccc" // light grey border
               borderRadius="8px" // rounded corners
               sx={{
                   position: "relative",
                   maxWidth: 900, // limit width
                   mx: "auto", // center horizontally
                   my: 2, // vertical spacing between each post
               }}
           >
                <Box display="flex" alignItems="flex-start" gap={1}>
              <Avatar
                src={photo.author?.profileImageUrl || '/default-avatar.jpg'}
                alt={`${photo.author?.first_name || ''} ${photo.author?.last_name || ''}`}
                sx={{ width: 62, height: 62 }}
              />
              <Box>
               <Typography variant="subtitle1" fontWeight="bold">
                {photo.author?.first_name && photo.author?.last_name
                  ? `${photo.author.first_name} ${photo.author.last_name}`
                  : 'Unknown Name'}
               </Typography>
               <Typography variant="body2" color="text.secondary">
                @{photo.author?.username || 'unknown'}
               </Typography>

               </Box>
            </Box>

            <CardMedia
              component="img"
              image={`http://localhost:3000${photo.imageUrl}`}
              alt="User photo"
              sx={{
                maxWidth: 900,       // large but still constrained
                width: '100%',
                display: 'block',
                margin: '16px auto 0 auto', // centers horizontally, adds top space
                borderRadius: 2,
                objectFit: 'contain'
              }}
            />

            <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
              {photo.description}
            </Typography>

            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block", mt: 0.5 }}
            >
              {new Date(photo.createdAt).toLocaleString()}
            </Typography>

                   <Box mt={2} display="flex" alignItems="center" gap={1}>
                       <Button
                           size="small"
                           variant={photo.voted ? "contained" : "outlined"}
                           //onClick={() => toggleVote(post._id)}
                           onClick={(e) => {
                               e.stopPropagation();
                               toggleVote(photo._id)}
                           }
                       >
                           ▲ {photo.voted ? "Unvote" : "Upvote"}
                       </Button>
                       <Typography variant="body2">{photo.upvotes} upvotes</Typography>
                   </Box>
           </Box>

           <Box
               p={2} // padding inside box
               my={2} // vertical margin between posts
               border="1px solid #ccc" // light grey border
               borderRadius="8px" // rounded corners
               sx={{
                   position: "relative",
                   maxWidth: 900, // limit width
                   mx: "auto", // center horizontally
                   my: 2, // vertical spacing between each post
               }}
           >
           <TextField
               fullWidth
               multiline
               rows={2}
               placeholder="Engage in intellectual discouse..."
               value={newComment}
               onChange={e => setNewComment(e.target.value)}
           />
           <Button variant="outlined" sx={{ mt: 1 }} onClick={handleSubmitComment}>
               Submit Comment
           </Button>
           </Box>




           {comments.length === 0 ? (
               <Typography>No comments yet.</Typography>
           ) : (
               comments.map((comment, i) => (
               <Box
                   p={2} // padding inside box
                   onClick={() => history.push(`/mainSocial/${id}/comments/${comment._id}`)}
                   my={2} // vertical margin between posts
                   border="1px solid #ccc" // light grey border
                   borderRadius="8px" // rounded corners
                   sx={{
                       position: "relative",
                       maxWidth: 900, // limit width
                       mx: "auto", // center horizontally
                       my: 2, // vertical spacing between each post
                       cursor: "pointer",
                       "&:hover": {
                           backgroundColor: "#f9f9f9"
                       }
                   }}
           >




                   <Box display="flex" alignItems="flex-start" gap={1}>
                               <Avatar
                                   src={comment.author?.profileImageUrl || '/default-avatar.jpg'}
                                   alt={`${comment.author?.first_name || ''} ${comment.author?.last_name || ''}`}
                                   sx={{ width: 62, height: 62 }}
                               />
                               <Box>
                                   <Typography variant="subtitle1" fontWeight="bold">
                                   {comment.author?.first_name && comment.author?.last_name
                                       ? `${comment.author.first_name} ${comment.author.last_name}`
                                       : 'Unknown Name'}
                                   </Typography>
                                   <Typography variant="body2" color="text.secondary">
                                   @{comment.author?.username || 'unknown'}
                                   </Typography>

                                   <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                       {comment.text}
                                   </Typography>

                                   <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                                       {`${new Date(comment.created_at).toLocaleString()}, ${comment.replies.length} ${comment.replies.length === 1 ? 'reply' : 'replies'}`}
                                       </Typography>

                               </Box>
                           </Box>




                           <Box mt={2} display="flex" alignItems="center" gap={1}>
                               <Button
                                   size="small"
                                   variant={comment.voted ? "contained" : "outlined"}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleCommentVote(comment._id)}
                                   }
                               >
                                   ▲ {comment.voted ? "Unvote" : "Upvote"}
                               </Button>
                               <Typography variant="body2">{comment.upvotes} upvotes</Typography>
                           </Box>


               </Box>
               ))
           )}
           <Dialog open={replyOpen} onClose={handleReplyClose}>
           <DialogTitle>Reply to Comment</DialogTitle>
           <DialogContent>
               <TextField
               autoFocus
               fullWidth
               multiline
               minRows={3}
               value={replyText}
               onChange={(e) => setReplyText(e.target.value)}
               placeholder="Write your reply..."
               />
           </DialogContent>
           <DialogActions>
               <Button onClick={handleReplyClose}>Cancel</Button>
               <Button onClick={handleReplySubmit} variant="contained">
               Post Reply
               </Button>
           </DialogActions>
           </Dialog>


    </div>
);


}


export default PhotosCommentsPage;
*/

//import React, { useEffect, useState } from 'react';
//import { useParams } from 'react-router-dom';
//import { Box, Typography, TextField, Button, Card, CardMedia, CardContent } from '@mui/material';
//import axios from 'axios';
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';
import { Box, Typography, TextField, Button, Link, Dialog, DialogTitle, DialogContent, DialogActions, Avatar, Card, CardMedia, CardContent } from '@mui/material';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';
import { useLocation, useHistory } from 'react-router-dom';

function PhotosCommentsPage() {
    const { postId } = useParams(); // get :postId from URL
    const [photo, setPhoto] = useState(null);
    const [newComment, setNewComment] = useState('');
    const [comments, setComments] = useState([]);

    const history = useHistory();
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');


    const [openDialog, setOpenDialog] = useState(false);
    const [comment, setComment] = useState("");
    const [activePostId, setActivePostId] = useState(null);


    const [replyOpen, setReplyOpen] = useState(false);
    const [replyText, setReplyText] = useState("");
    const [activeCommentId, setActiveCommentId] = useState(null);

    const [image, setImage] = useState(null);
    const [description, setDescription] = useState('');

    const [photoFileName, setPhotoFileName] = useState("");

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setImage(file);
        setPhotoFileName(file?.name || "");
    };

    const handlePost = async () => {
        if (!image) return alert("Select a photo first");

        const formData = new FormData();
        formData.append("image", image);
        formData.append("description", description);

        try {
            await axios.post('/photos/postPhotos', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            withCredentials: true  
            });
            setOpen(false);
            setImage(null);
            setDescription('');
            //alert("Photo posted!");
        } catch (err) {
            console.error(err);
            alert("Upload failed");
        }
    };

    /*
    useEffect(() => {
        axios.get(`/photo/${postId}`)
            .then(res => {
            const sortedComments = [...res.data.comments].sort(
                (a, b) => (b.upvoters?.length || 0) - (a.upvoters?.length || 0)
            );
            setPhoto({ ...res.data, comments: sortedComments });
            })
            .catch(err => console.error("Failed to load post", err));
    }, [postId]);*/
    // fetch main social photos 
   useEffect(() => {
       axios.get(`/photo/${postId}`)
           .then(res => setPhoto(res.data))
           .catch(err => console.error("Error loading case", err));
       }, [postId]);

    // Fetch comments
   /*useEffect(() => {
   axios.get(`/photo/${postId}/comments`)
       .then(res => setComments(res.data))
       .catch(err => console.error("Error loading comments", err));
   }, [postId]);*/
   const [cursor, setCursor] = useState(null);
   const [loading, setLoading] = useState(false);
   const [hasMore, setHasMore] = useState(true);
   const fetchComments = async () => {
       if (loading || !hasMore) return;
       try {
           setLoading(true);
           const res = await axios.get(`/photo/${postId}/comments`, {
               params: { cursor, limit: 10 }
           });
           setComments(prev => {
               const existingIds = new Set(prev.map(c => c._id));
               const newComments = res.data.comments.filter(c => !existingIds.has(c._id));
               return [...prev, ...newComments];
           });
           setCursor(res.data.nextCursor);
           setHasMore(res.data.hasMore);
       } catch (err) {
           console.error("Error loading comments", err);
       } finally {
           setLoading(false);
       }
   };
   useEffect(() => {
       setComments([]);
       setCursor(null);
       setHasMore(true);
   }, [postId]);
   useEffect(() => {
       fetchComments();
   }, [postId]);
   const observer = useRef();
   const lastCommentRef = useCallback(node => {
       if (loading) return;
       if (observer.current) observer.current.disconnect();
       observer.current = new IntersectionObserver(entries => {
           if (entries[0].isIntersecting && hasMore) {
           fetchComments();
           }
       });
       if (node) observer.current.observe(node);
   }, [loading, hasMore]);

   /*const handleSubmitComment = async () => {
       if (!newComment.trim()) return;

       try {
           const res = await axios.post(`/photo/${postId}/comment`, { text: newComment }); // NOTE: single 'comment'
           setComments(prev => [res.data, ...prev]);
           setNewComment('');
       } catch (err) {
           console.error("Error submitting comment", err);
       }
   };*/
   const handleSubmitComment = async () => {
      if (!newComment.trim()) return;

      try {
          const res = await axios.post(`/photo/${id}/comment`, {
               text: newComment,
           });

          //const commentRes = await axios.get(`/photo/${id}/comments`);
          //setComments(commentRes.data);
          setComments(prev => [res.data, ...prev]);
          setNewComment('');
      } catch (err) {
          console.error("Error submitting comment", err);
      }
  };


   const toggleVote = async (postId) => {
       try {
           const res = await axios.post(`/photos/${postId}/upvote`);
           const { upvotes, voted } = res.data;


           setPhoto(prevCase => ({
               ...prevCase,
               upvotes,
               voted
           }));
       } catch (err) {
           console.error('Error toggling vote:', err);
       }
   };

   const handleOpenDialog = (scotusCaseId) => {
      setActivePostId(scotusCaseId);
      setOpenDialog(true);
   };


   /*const toggleCommentVote = async (commentId) => {
       try {
               // hit backend endpoint that toggles a vote
               const res = await axios.post(`/photoComments/${commentId}/upvote`);


               // update <posts> in react state so ui rerenders
               // setPosts(prev => ...) receives the previous array of posts and must return a new array
               // prev.map( p => { ... } )
               // iterate through every post p in old array
               // if p is the one user just voted on, return a new object with the fresh upvote info from server
               // otherwise, return p unchanged
           setComments((prev) =>
               prev.map((p) =>
                   p._id === commentId
                       ? {
                           ...p, // copy exisiting post fields
                           upvotes: res.data.upvotes, // updated count
                           voted:   res.data.voted // true or false that user voted
                       }
                       : p // all other posts unchanged
               )
           );




       } catch(err) {
           console.error("Vote error", err);
       }
   };*/
   const toggleCommentVote = async (commentId) => {
       try {
           const res = await axios.post(`/photoComments/${commentId}/upvote`);
           //const commentRes = await axios.get(`/photo/${postId}/comments`);
           //setComments(commentRes.data);
           setComments(prev =>
                prev.map(c =>
                    c._id === commentId
                    ? { ...c, upvotes: res.data.upvotes, voted: res.data.voted }
                    : c
                )
            );
       } catch(err) {
           console.error("Vote error", err);
       }
   };

   const handleReplyOpen = (commentId) => {
       setActiveCommentId(commentId);
       setReplyOpen(true);
   };


   const handleReplyClose = () => {
       setReplyOpen(false);
       setReplyText("");
       setActiveCommentId(null);
   };



   const handleReplySubmit = async () => {
       if (!replyText.trim()) return;


       try {
       const res = await axios.post(`/photo/comments/${activeCommentId}/replies`, {
           text: replyText
       });


       // Update state with new reply
       setComments(prev =>
           prev.map(c =>
           c._id === activeCommentId
               ? { ...c, replies: [...(c.replies || []), res.data] }
               : c
           )
       );


       handleReplyClose();
       } catch (err) {
       console.error("Reply error", err);
       }
   };

    // Submit new comment to backend
    const handleAddComment = async () => {
        if (!newComment.trim()) return; // prevent empty comments
        try {
            const res = await axios.post(`/photo/${postId}/comment`, { text: newComment });
            setPhoto(prev => ({
                ...prev,
                comments: res.data, // update comment list from response
            }));
            setNewComment(''); // clear input
        } catch (err) {
            console.error("Failed to add comment", err);
        }
    };
  
    // Upvote the main post
    const handlePostUpvote = async () => {
        try {
            const res = await axios.post(`/photo/${postId}/upvote`);
            setPhoto(prev => ({
            ...prev,
            upvoters: Array(res.data.upvotes).fill(1), // just update the count visually
            }));
        } catch (err) {
            console.error("Failed to upvote post", err);
        }
    };
/*
    // Upvote a comment
    const handleCommentUpvote = async (commentId) => {
        try {
            const res = await axios.post(`/photo/${postId}/comment/${commentId}/upvote`);
            setPost(prev => ({
            ...prev,
            comments: prev.comments.map(c =>
                c._id === commentId
                ? { ...c, upvoters: Array(res.data.upvotes).fill(1) }
                : c
            ),
            }));
        } catch (err) {
            console.error("Failed to upvote comment", err);
        }
    };*/

    const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

  if (!photo) return <Typography>Loading...</Typography>;

  let id = postId;

  const location = useLocation();
   const source = location.state?.source;
    const navItems = [
        {
            label: "Popular",
            path: "/mainsocial/photos/popular",
            matchPaths:
            source === "popular"
                ? ["/mainsocial/photos/popular", "/photos"]
                : ["/mainsocial/photos/popular"]
        },
        {
            label: "Following",
            path: "/mainsocial/photos/following",
            matchPaths:
            source === "following"
                ? ["/mainsocial/photos/following", "/photos"]
                : ["/mainsocial/photos/following"]
        },
    ];

    const getButtonStyles = (item) => {
      //const active = location.pathname.startsWith(path);
      const active = item.matchPaths
        ? item.matchPaths.some(path => location.pathname.startsWith(path))
        : location.pathname.startsWith(item.path);

      return {
        padding: "6px 12px",
        borderColor: active ? "#1f1f1f" : "#333333",
        color: active ? "#1f1f1f" : "#333333",
        backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",
        "&:hover": {
          borderColor: "black",
          color: "black",
          backgroundColor: "rgba(0,0,0,0.12)"
        }
      };
    };
  return (
       <div
          style={{
              padding: '20px',
              backgroundColor: '#FFFDF8',
              minHeight: '100vh',  // ensures it covers the full viewport height
              boxSizing: 'border-box', // ensures padding doesn't affect layout
          }}
      >

          <div style={{ width: '200px' }}></div>

          {/* Centered Buttons */}
            {/*<Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
            <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/photos/popularPhotos')}
                    >
                        Popular
                    </Button>
            <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/photos/followingPhotos')}
                    >
                        Following
                    </Button>
            <>
                <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => setOpen(true)}
                    >
                        Post Photo
                    </Button>*/}
                {/* Sticky Navigation */}
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#FFFDF8",
                  //borderBottom: "1px solid rgba(0,0,0,0.08)",
                  py: 2
                }}
              >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                  flexWrap="wrap"
                >
                  {navItems.map((item) => (
                    <Button
                      key={item.path}
                      variant="outlined"
                      sx={getButtonStyles(item)}
                      onClick={() => history.push(item.path)}
                    >
                      {item.label}
                    </Button>
                  ))}

                  <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => setOpen(true)}
                    >
                        Post Photo
                    </Button>
                    </Box>
                    <Box sx={{ minWidth: 220 }} />
                </Box>
              </Box>
                <Dialog
                  open={open}
                  onClose={() => setOpen(false)}
                  maxWidth="sm"
                  fullWidth
                  PaperProps={{
                      sx: {
                      backgroundColor: "#FFFDF8",
                      borderRadius: 3,
                      },
                  }}
                  >
                    <DialogTitle sx={{ fontWeight: "bold" }}>Post a Photo</DialogTitle>
                    <DialogContent
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          pt: 1,
                        }}
                    >
                      {/* Upload Photo Button */}
                      <Button variant="outlined" component="label">
                        Upload Photo
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={handleFileChange}
                        />
                      </Button>

                      {/* Selected filename */}
                      {photoFileName && (
                        <Typography variant="caption" color="text.secondary">
                          Selected photo: {photoFileName}
                        </Typography>
                      )}
                    <TextField
                        fullWidth
                        multiline
                        rows={2}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Write a description"
                        margin="normal"
                    />
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button onClick={handlePost} variant="contained">Post</Button>
                    </DialogActions>
                </Dialog>
            {/*</>*/}
            {/*</Box>*/}

           <Box
               p={2} // padding inside box
               my={2} // vertical margin between posts
               border="1px solid #ccc" // light grey border
               borderRadius="8px" // rounded corners
               sx={{
                   position: "relative",
                   maxWidth: 900, // limit width
                   mx: "auto", // center horizontally
                   my: 2, // vertical spacing between each post
               }}
           >
                <Box display="flex" alignItems="flex-start" gap={1}>
              <Avatar
                src={photo.author?.profileImageUrl || '/default-avatar.jpg'}
                alt={`${photo.author?.first_name || ''} ${photo.author?.last_name || ''}`}
                onClick={(e) => visitProfile(e, photo.author?._id)}
                           sx={{ 
                            width: 62, 
                            height: 62,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#d9e4f0",
                            }, 
                            }}
              />
              <Box>
               <Typography variant="subtitle1" fontWeight="bold"
               onClick={(e) => visitProfile(e, photo.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
               >
                {photo.author?.first_name && photo.author?.last_name
                  ? `${photo.author.first_name} ${photo.author.last_name}`
                  : 'Unknown Name'}
               </Typography>
               <Typography variant="body2" color="text.secondary"
               onClick={(e) => visitProfile(e, photo.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
               >
                @{photo.author?.username || 'unknown'}
               </Typography>

               </Box>
            </Box>

            <CardMedia
              component="img"
              image={photo.imageUrl}
              alt="User photo"
              sx={{
                maxWidth: 900,       // large but still constrained
                width: '100%',
                display: 'block',
                margin: '16px auto 0 auto', // centers horizontally, adds top space
                borderRadius: 2,
                objectFit: 'contain'
              }}
            />

            <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
              {photo.description}
            </Typography>

            {/*<Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block", mt: 0.5 }}
            >
              {`${new Date(photo.createdAt).toLocaleString()}, ${photo.comments.length} ${photo.comments.length === 1 ? 'reply' : 'replies'}`}
            </Typography>*/}
            <Typography
                variant="caption"
                color="text.secondary"
                sx={{ display: "block", mt: 0.5 }}
            >
                {`${new Date(photo.created_at).toLocaleString()}, ${
                    photo.commentCount
                  } ${photo.commentCount === 1 ? 'reply' : 'replies'}`}
            </Typography>

                   {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                       <Button
                           size="small"
                           variant={photo.voted ? "contained" : "outlined"}
                           //onClick={() => toggleVote(post._id)}
                           onClick={(e) => {
                               e.stopPropagation();
                               toggleVote(photo._id)}
                           }
                       >
                           ▲ {photo.voted ? "Unvote" : "Upvote"}
                       </Button>
                       <Typography variant="body2">{photo.upvotes} upvotes</Typography>
                   </Box>*/}
                   <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {photo.voted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleVote(photo._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleVote(photo._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{photo.upvotes} Power Votes</Typography>
                   </Box>
           </Box>

           <Box
               p={2} // padding inside box
               my={2} // vertical margin between posts
               border="1px solid #ccc" // light grey border
               borderRadius="8px" // rounded corners
               sx={{
                   position: "relative",
                   maxWidth: 900, // limit width
                   mx: "auto", // center horizontally
                   my: 2, // vertical spacing between each post
               }}
           >
           <TextField
               fullWidth
               multiline
               rows={2}
               placeholder="Engage in intellectual discourse..."
               value={newComment}
               onChange={e => setNewComment(e.target.value)}
           />
           <Button variant="outlined" sx={{ mt: 1 }} onClick={handleSubmitComment}>
               Reply
           </Button>
           </Box>




           {comments.length === 0 ? (
               <Typography></Typography>
           ) : (
               comments.map((comment, i) => {
                const isLast = i === comments.length - 1;
                return (
               <Box
                   key={comment._id}
                   ref={isLast ? lastCommentRef : null}
                   p={2} // padding inside box
                   //onClick={() => history.push(`/photo/${id}/comments/${comment._id}`)}
                   onClick={() => history.push(`/photo/${id}/comments/${comment._id}`, { source: source })}
                   my={2} // vertical margin between posts
                   border="1px solid #ccc" // light grey border
                   borderRadius="8px" // rounded corners
                   sx={{
                       position: "relative",
                       maxWidth: 900, // limit width
                       mx: "auto", // center horizontally
                       my: 2, // vertical spacing between each post
                       cursor: "pointer",
                       "&:hover": {
                           backgroundColor: "#f9f9f9"
                       }
                   }}
           >




                   <Box display="flex" alignItems="flex-start" gap={1}>
                               <Avatar
                                   src={comment.author?.profileImageUrl || '/default-avatar.jpg'}
                                   alt={`${comment.author?.first_name || ''} ${comment.author?.last_name || ''}`}
                                   onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{ 
                                        width: 62, 
                                        height: 62,
                                        cursor: "pointer",
                                        "&:hover": {
                                            backgroundColor: "#d9e4f0",
                                        }, 
                                        }}
                               />
                               <Box>
                                   <Typography variant="subtitle1" fontWeight="bold"
                                   onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "inline-block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "currentColor", 
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                                   >
                                   {comment.author?.first_name && comment.author?.last_name
                                       ? `${comment.author.first_name} ${comment.author.last_name}`
                                       : 'Unknown Name'}
                                   </Typography>
                                   <Typography variant="body2" color="text.secondary"
                                   onClick={(e) => visitProfile(e, comment.author?._id)}
                                    sx={{
                                        cursor: "pointer",
                                        display: "block",
                                        "&:hover": {
                                        textDecoration: "underline",
                                        textDecorationColor: "#currentColor",
                                        textUnderlineOffset: "3px",
                                        },
                                    }}
                                   >
                                   @{comment.author?.username || 'unknown'}
                                   </Typography>

                                   <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                                       {comment.text}
                                   </Typography>

                                   {/*<Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                                       {`${new Date(comment.created_at).toLocaleString()}, ${comment.replies.length} ${comment.replies.length === 1 ? 'reply' : 'replies'}`}
                                       </Typography>*/}
                                    <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                                        {`${new Date(comment.created_at).toLocaleString()}, ${
                                            comment.replyCount ?? 0
                                        } ${comment.replyCount === 1 ? "reply" : "replies"}`}
                                    </Typography>

                               </Box>
                           </Box>




                           {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
                               <Button
                                   size="small"
                                   variant={comment.voted ? "contained" : "outlined"}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleCommentVote(comment._id)}
                                   }
                               >
                                   ▲ {comment.voted ? "Unvote" : "Upvote"}
                               </Button>
                               <Typography variant="body2">{comment.upvotes} upvotes</Typography>
                           </Box>*/}
                           <Box mt={2} display="flex" alignItems="center" gap={1}>
                            {comment.voted ? (
                                <Box
                                sx={{
                                    position: "relative",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    "&:hover .voted-btn": {
                                        opacity: 0,
                                    },
                                    "&:hover .undo-btn": {
                                        opacity: 1,
                                        pointerEvents: "auto",
                                    },
                                }}
                            >
                                    <Button
                                        size="small"
                                        className="voted-btn"
                                        variant="contained"
                                        color="success"
                                        disabled
                                        sx={{
                                        transition: "opacity 0.2s ease",
                                        }}
                                    >
                                    Power Voted
                                </Button>
                                <Button
                                        size="small"
                                        className="undo-btn"
                                        variant="contained"
                                        color="error"
                                        sx={{
                                        inset: 0,
                                        position: "absolute",
                                        transition: "opacity 0.2s ease",
                                        opacity: 0,
                                        pointerEvents: "none",
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleCommentVote(comment._id)
                                    }}
                                >
                                        Undo
                                </Button>
                            </Box>
                            ) : (
                                <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    toggleCommentVote(comment._id)}
                                }
                                >
                                    ▲ Power Vote
                                </Button>
                            )}
                            <Typography variant="body2">{comment.upvotes} Power Votes</Typography>
                    </Box>


               </Box>
               )})
           )}
    </div>
);

  /*
  return (
    <Box p={4}>
      <Box mb={4} p={2} border="1px solid #ccc" borderRadius="8px">
        <Typography variant="subtitle1" fontWeight="bold">
          @{post.author?.username || "Unknown"}
        </Typography>
        <CardMedia
            component="img"
            image={`http://localhost:3000${post.imageUrl}`}  
            alt="User photo"
            sx={{ maxHeight: 500, objectFit: 'cover' }}
          />
        <Typography variant="caption" display="block">
          {new Date(post.created_at).toLocaleString()}
        </Typography>
        <Typography mt={1} variant="body2">
          👍 {post.upvoters?.length || 0} upvotes
        </Typography>
        <Button variant="outlined" size="small" onClick={handlePostUpvote}>
            Upvote
        </Button>
      </Box>

      <Box mb={2}>
        <TextField
          label="Add a comment"
          variant="outlined"
          fullWidth
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
        />
        <Button
          variant="contained"
          onClick={handleAddComment}
          sx={{ mt: 1 }}
        >
          Submit
        </Button>
      </Box>

      {post.comments.map((comment, i) => (
        <Box key={i} ml={2} mt={1}>
            <Typography variant="body2">
                <strong>@{comment.author?.username || "Anonymous"}:</strong> {comment.text}
            </Typography>
                <Typography variant="caption" display="block">
                    👍 {comment.upvoters?.length || 0} upvotes
                </Typography>
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => handleCommentUpvote(comment._id)}
                >
                    Upvote
                </Button>
        </Box>
    ))}
    </Box>
  );*/
}

export default PhotosCommentsPage;
